module.exports = __webpack_public_path__ + "img/PL08816.d9c1749e.png";